<template xmlns:v-on="http://www.w3.org/1999/xhtml">
    <div id="page-content-wrapper" class="admin-content-area">
        <div v-if="userPermissions.indexOf('access_social_media_calendar') > -1" class="container-fluid xyz">
            <div class="page-name">
                {{pageTitle}}
                <button type="submit" class="back_button btn btn-primary pull-right" v-on:click.prevent="buttonBack">Back</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <form id="socialMediaForm">
                    <!--Title-->
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="form-group">
                            <label for="title">Title<span class="text-danger">*</span></label>
                            <input v-model="title" type="text" class="form-control" id="title" placeholder="Title">
                            <font class="text-danger">{{titleError}}</font>
                        </div>
                    </div>
                    <!--Description-->
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="form-group">
                            <label for="description">Description<span class="text-danger">*</span></label>
                            <!--<input v-model="description" type="text" class="form-control" id="description" placeholder="Description">-->
                            <tinymce :plugins="['advlist autolink lists link image charmap print preview hr anchor pagebreak', 'searchreplace wordcount visualblocks visualchars code fullscreen', 'insertdatetime media nonbreaking save table contextmenu directionality','template paste textcolor colorpicker textpattern imagetools toc help emoticons hr codesample']" id="description" v-model="description" class= "" ref="tm" ></tinymce>
                            <font class="text-danger">{{descriptionError}}</font>
                        </div>
                    </div>
                    <!--Hash Tags-->
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="form-group">
                            <label for="hashTag">Hash Tags</label>
                            <textarea v-model="hashTag" class="form-control" id="hashTag" placeholder="Hash Tags"></textarea>
                        </div>
                    </div>
                    <!--Attachments-->
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="form-group">
                            <label for="dropzone">Attachments</label>
                            <vue-dropzone
                                ref="dropzone" 
                                id="dropzone" 
                                :options="dropzoneOptions"
                                @vdropzone-success = "uploadDocument"
                                @vdropzone-removed-file="removedSelectedFile"
                                @vdropzone-error="fileError"
                                @vdropzone-file-added="fileAdd"
                                :useCustomSlot=true
                                >
                                <div class="dropzone-custom-content">
                                    <h4 class="dropzone-custom-title">Drop files here or click to upload.</h4>
                                    <div class="subtitle">(Select files from your computer.)</div>
                                </div>
                            </vue-dropzone>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <div class="form-group">
                            <label for="companies">Companies To Share With<span class="text-danger">*</span></label>
                            <v-select v-model="companies"
                                      multiple
                                      @change="changedValue"
                                      @input="changedValueCompany()"
                                      name="companies"
                                      id="companies"
                                      label="text"
                                      :filterable="false"
                                      :options="companyArr"
                                      :searchable="false"
                                      placeholder="Select Company">
                            </v-select>
                            <font class="text-danger">{{companyError}}</font>
                        </div>
                    </div>
                    <!--Date-->
                    <div class="StartDate col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <div class="form-group">
                            <label for="startDate" slot="before">Date<span class="text-danger">*</span></label>
                            <datePicker id="StartDate" v-model="startDate" :config="optionsStart" @dp-change="changeStartDt()"></datePicker>
                            <font class="text-danger">{{startDateError}}</font>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                    <!--Contact Person-->
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <div class="form-group">
                            <label for="userId">Contact Person<span class="text-danger">*</span></label>
                            <input v-model="userId" type="text" class="form-control" id="userId" placeholder="Contact Person">
                            <font class="text-danger">{{contactPersonError}}</font>
                        </div>
                    </div>
                    <!--Contact Email-->
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <div class="form-group">
                            <label for="contactEmail">Contact Email<span class="text-danger">*</span></label>
                            <input v-model="contactEmail" type="text" class="form-control" id="contactEmail" placeholder="Contact Email">
                            <font class="text-danger">{{contactEmailError}}</font>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                    <!--Conatct Number-->
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <div class="form-group">
                            <label for="contactNumber">Contact Number</label>
                            <input v-model="contactNumber" type="text" class="form-control" id="contactNumber" placeholder="Contact Number">
                            <font class="text-danger">{{contactNumberError}}</font>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <div class="form-group">
                            <label for="createdBy">{{createdByTitle}}</label>
                            <span class="form-control" id="createdBy">{{createdBy}}</span>
                        </div>
                    </div>
                    <div class="clearfix"></div>

                    <!--Error Alert-->
                    <div class="row clearfix" >
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div class="alert alert-danger" id="alertError">
                                <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                <strong id="errorMsg" class="error"></strong>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                    <!--Buttons-->
                    <div class="row clearfix"></div>
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div class="button-demo">
                            <input id="addSocialMediaBtn" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="addEvent()">
                            <input id="addAndContinueSocialMediaBtn" type="submit" value="Save and Continue" class="btn btn-primary" v-on:click.prevent="addEvent(flag='Save and Continue')">
                            <input id="CancelSocialMedia" type="submit" value="Cancel" class="back_button btn btn-primary" v-on:click.prevent="buttonBack">
                        </div>
                    </div>
                </form>
            </div>
            <!--page content-->
        </div>
        <div v-else class="container-fluid xyz">
            <div class="page-name">
                Oops...!
            </div>
            <div class="admin-page-content">
                Sorry, You don't have permission to access this page.
            </div>
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- /#page-content-wrapper -->
</template>

<script>
    var self;
    import vSelect from 'vue-select';
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/Footer';
    import SessioMixin from '../../../mixins/sessionmixin';
    import { HTTP } from '../../../http-common';
    import moment from 'moment';
    import EventBus from '../../event-bus';

    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';

    import datePicker from 'vue-bootstrap-datetimepicker';
    import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

    import tinymce from 'vue-tinymce-editor';

    export default {
        name: 'AddEvent',
        pageTitle: 'Add Social Media Calender Entry',
        mixins: [SessioMixin],
        components: {
            'v-select': vSelect,
            'datePicker': datePicker,
            'app-backend-footer': BackendFooter,
            'tinymce': tinymce,
            "vueDropzone": vue2Dropzone,
        },
        data() {
            return {
                isShowLoggedinfields: true,
                userPermissions: ['access_social_media_calendar'],
                roleId: 0,
                roleName: 0,
                system_year: '',
                createdByTitle: '',
                createdBy: '',
                pageTitle: '',
                title: '',
                companies: '',
                companyArr: [],
                /*startDate: '',*/
                startDate: new Date(),
                optionsStart: {
                    format: 'MM/DD/YYYY',
                    /*format: 'MM/DD/YYYY hh:mmA',
                     dayViewHeaderFormat: 'MMM DD YYYY hh:mm',
                     minDate: new Date(),
                     minDate: new Date(new Date().setDate(new Date().getDate() - 1)),
                     maxDate: new Date(new Date().setMonth(new Date().getMonth() + 1000)),*/
                },
                dropzoneOptions: {
                    timeout: 3000000,
                    url: process.env.ROOT_API + "/store_document",
                    method: "POST",
                    paramName: 'file',
                    autoProcessQueue: true,
                    maxFilesize: 250, //MB
                    dictFileTooBig: "File is too big ({{filesize}}MB). Max allowed file size is {{maxFilesize}}MB",
                    thumbnailWidth: 150, //px
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    dictCancelUpload: 'Cancel',
                    dictRemoveFile: "Remove",
                    //acceptedFiles: ".jpg, .jpeg, .png",
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        // 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE',
                        // 'Access-Control-Allow-Headers': 'Content-Type, Authorization, X-Requested-With',//'Origin, X-Requested-With, Content-Type, Accept, X-File-Name, X-File-Size, X-File-Type',
                        //'Content-Type': 'application/x-www-form-urlencoded'
                    }
                },
                description: '',
                hashTag: '',
                userId: '',
                userArr: [],
                contactPerson: '',
                contactEmail: '',
                contactNumber: '',
                //Errors
                titleError: '',
                companyError: '',
                descriptionError: '',
                startDateError: '',
                contactPersonError: '',
                contactEmailError: '',
                contactNumberError: '',
                //Files
                imagesPaths: [],
                imagesType: [],
                imagesSize: [],
                loadDocArr: [],
            }
        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
        },
        mounted: function () {
            var path = window.location.pathname;
            var segments = path.split("/");

            var userObj = localStorage.getItem("user_obj");
            var userJson = [];
            if (userObj != null) {
                userJson = JSON.parse(userObj);
            } else {
                self.$router.push("/login");
            }
            if (segments[2] == 'updatesocialmediaentry') {
                if (segments[3]) {
                    self.createdByTitle = 'Last Updated By';
                    self.pageTitle = 'Edit Social Media Calender Entry';
                    self.loadEvent();
                    $("#addAndContinueSocialMediaBtn").hide();
                    $("#addSocialMediaBtn").val("Update");
                }
            } else {
                self.createdByTitle = 'Created By';
                self.pageTitle = 'Add Social Media Calender Entry';
                self.createdBy = self.userId = userJson.first_name + " " + userJson.last_name;
                self.contactEmail = userJson.email;
                self.contactNumber = userJson.phone;
            }
            $("#title").on('keyup', function () {
                self.titleError = '';
            });
            $("#startDate").on('keyup', function () {
                self.startDateError = '';
            });
            $("#userId").on('keyup', function () {
                self.contactPersonError = '';
            });
            $("#contactEmail").on('keyup', function () {
                self.contactEmailError = '';
            });
            $("#contactNumber").on('keyup', function () {
                self.contactNumberError = '';
            });
            $("#companies").on('keyup', function () {
                self.companyError = '';
            });
            $("#alertError").hide();
            self.getPermissions();
            self.loadCompanies();
        },
        watch: {
            description: function (description) {
                /*self.descriptionError = (description.length > 0) ? "" : "Description Required";*/
                if (description.length > 0) {
                    self.descriptionError = "";
                }
            },
        },
        methods: {
            uploadDocument: function (file, response) {
                var self = this;
                //console.log(file);
                /* self.isFileUploaded = true; */
                self.imagesPaths.push(response.content);
                //console.log(self.imagesPaths);

                self.imagesType.push(file.type);
                self.imagesSize.push(file.size);
                this.$refs.dropzone.setOption('maxFiles', null);
            },
            uploadManually: function (file) {

                var self = this;
                for (var i = 0; i < self.loadDocArr.length; i++) {

                    var url = self.loadDocArr[i]['url'];
                    var file_name = self.getFileName(self.loadDocArr[i]['url']);
                    /*var file_type = self.getFileType(self.loadDocArr[i]['extension']);*/
                    var file_type = self.loadDocArr[i]['file_type'];
                    var file_size = self.loadDocArr[i]['size'];

                    self.imagesType.push(file_type);
                    self.imagesSize.push(Number(file_size));

                    var file_data = {size: file_size, fileid: file_name, name: file_name, type: file_type};
                    self.$refs.dropzone.manuallyAddFile(file_data, url);
                }
                /* console.log("Accepted");
                 console.log(this.$refs.dropzone.getAcceptedFiles());
                 console.log("Rejected");
                 console.log(this.$refs.dropzone.getRejectedFiles()); */

                //this.$refs.dropzone.addRemoveLinks = true;

            },
            removedSelectedFile: function (file, xhr, error) {

                /* console.log(JSON.stringify(this.$refs.dropzone.dropzone.options)); */
                this.$refs.dropzone.setOption('maxFiles', null);
                var self = this;
                var removeFile = "";
                if (this.$refs.dropzone.dropzone.options.maxFiles) {
                    this.$refs.dropzone.setOption('maxFiles', null);
                }
                /* if (self.imagesPaths.length <= 0) {
                 self.isFileUploaded = false;
                 } */
                if ("manuallyAdded" in file == true) {
                    for (var i = self.imagesPaths.length - 1; i >= 0; i--) {
                        if (self.imagesPaths[i].indexOf(file.name) != -1) {
                            removeFile = self.imagesPaths[i];
                        }
                    }
                    this.$refs.dropzone.setOption('maxFiles', null);
                } else {
                    var filePath = JSON.parse(file.xhr.response);
                    removeFile = filePath.content;
                    //console.log(removeFile);return false;
                    self.removeFileFromServer(removeFile);
                }
                for (var i = self.imagesPaths.length - 1; i >= 0; i--) {
                    if (self.imagesPaths[i] === removeFile) {
                        self.imagesPaths.splice(i, 1);
                        self.imagesType.splice(i, 1);
                        self.imagesSize.splice(i, 1);
                        //break;       //<-- Uncomment  if only the first term has to be removed
                    }
                }
                this.$refs.dropzone.setOption('maxFiles', null);
                /* console.log(JSON.stringify(this.$refs.dropzone.dropzone.options)); */

            },
            removeFileFromServer: function (filePath) {

                var self = this;
                //console.log(filePath);return false;
                var config = {
                    headers: {"Authorization": "Bearer " + localStorage.getItem("api_token")},
                    data: {
                        filePath: filePath,
                    }
                };
                HTTP.delete('removemedia', config)
                        .then(function (response) {
                            /*console.log("File removed successfully");*/
                        })
                        .catch(function (err) {
                            //self.catchHandler(err, function () {});
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            fileAdd: function (file, xhr, error) {
                if (this.$refs.dropzone.dropzone.options.maxFiles) {
                    this.$refs.dropzone.setOption('maxFiles', null);
                }
                /* console.log("File Add"); */
            },
            getFileType: function (file_name) {

                var type = file_name.split('.');
                var file_type = type[type.length - 1];
                return 'image/' + file_type;
            },
            getFileName: function (file) {

                var self = this;
                var src = file.split('/');
                var file_name = src[src.length - 1];
                var orgPath = src[src.length - 2]

                self.imagesPaths.push(String(orgPath + "/" + file_name));

                return file_name;
            },
            fileError: function (file, xhr, error) {
                /* console.log("File Error"); */
            },
            removeAllFiles: function () {
                this.$refs.dropzone.removeAllFiles();
            },
            buttonBack() {
                $(".back_button").prop("disabled", false);
                self.$router.push('/backend/listsocialmediacalendar');
            },
            changeStartDt: function () {
                self.startDateError = "";
            },
            changeStartDate: function () {
                self.startDateError = "";
            },
            changedValue: function (value) {
                //console.log(value);
            },
            changedValueCompany: function () {
                self.companyError = "";
            },
            checkForm: function () {
                var checked = true;
                self.contactPersonError = "";
                self.descriptionError = "";
                self.companyError = "";
                if (!self.description) {
                    self.descriptionError = "Description Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.companies.length === 0) {
                    self.companyError = "Company Required";
                    if (checked) {
                        checked = false;
                    }
                }
                self.startDateError = "";
                if (!self.startDate) {
                    self.startDateError = "Date Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.userId) {
                    self.contactPersonError = 'Please Enter Contact Person';
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.contactEmail) {
                    self.contactEmailError = 'Please Enter Contact Email';
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.contactEmail && !self.validEmail(self.contactEmail)) {
                    self.contactEmailError = 'Please Enter Valid Contact Email';
                    if (checked) {
                        checked = false;
                    }
                }
                /*console.log(String(self.contactNumber));*/
                if (self.contactNumber && !String(self.contactNumber).match(/^[0-9]*$/)) {
                    self.contactNumberError = "Phone Number Must Be Numeric";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.contactNumber && String(self.contactNumber).match(/^[0-9]*$/) && self.contactNumber.length < 10) {
                    self.contactNumberError = "Phone Number Must Be Of Minimum 10 Digits";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.contactNumber && String(self.contactNumber).match(/^[0-9]*$/) && self.contactNumber.length > 13) {
                    self.contactNumberError = "Phone Number Must Be Of Maximum 13 Digits";
                    if (checked) {
                        checked = false;
                    }
                }
                self.titleError = "";
                if (!self.title) {
                    self.titleError = "Title Required";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.title.length > 190) {
                    self.titleError = "Title cannot be longer than 190 character";
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },

            validEmail: function (email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
            loadEvent() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        id: segments[3],
                    }
                };
                HTTP.get("getsocialentry", config)
                        .then(function (response) {
                            self.title = response.data.content.title;
                            self.description = response.data.content.description;
                            self.hashTag = response.data.content.has_tags;
                            self.userId = response.data.content.contact_person;
                            self.contactEmail = response.data.content.contact_email;
                            self.contactNumber = response.data.content.contact_number;
                            self.createdBy = response.data.content.last_updated_by;
                            self.loadDocArr = response.data.content.attachments;
                            self.uploadManually();
                            self.companies = [];
                            for (var i = 0; i < response.data.content.selected_company.length; i++) {
                                self.companies.push({'text': response.data.content.selected_company[i].name, 'value': response.data.content.selected_company[i].id});
                            }
                            setTimeout(function () {
                                self.startDate = moment(response.data.content.start_date_time).format("MM/DD/YYYY");
                            }, 200);

                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },

            addEvent(flag) {
                self.checkForm();
                if (self.checkForm()) {
                    var userJson = [];
                    var userObj = localStorage.getItem("user_obj");
                    if (userObj != null) {
                        userJson = JSON.parse(userObj);
                    } else {
                        self.$router.push("/login");
                    }
                    var path = window.location.pathname;
                    var segments = path.split("/");
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                    };
                    var companiesId = '';
                    for (var i = 0; i < self.companies.length; i++) {
                        companiesId += (self.companies[i].value) + ',';
                    }
                    companiesId = companiesId.replace(/,\s*$/, "");
                    var start_date = self.startDate;
                    if (segments[2] == 'updatesocialmediaentry') {
                        if (segments[3]) {
                            var data = {
                                title: self.title,
                                imagePath: self.imagesPaths,
                                imageSize: self.imagesSize,
                                imageType: self.imagesType,
                                companies_id: companiesId,
                                description: self.description,
                                hashtag: self.hashTag,
                                startDate: start_date,
                                contactPerson: self.userId,
                                contactEmail: self.contactEmail,
                                contactNumber: self.contactNumber,
                                id: segments[3],
                            };
                            $("#addSocialMediaBtn").val("Updating ...");
                            $("#addSocialMediaBtn").prop("disabled", true);
                            $("#CancelSocialMedia").prop("disabled", true);
                        } else {
                            if (flag == "Save and Continue") {
                                $("#addAndContinueSocialMediaBtn").val("Saving ...");
                                $("#addAndContinueSocialMediaBtn").prop("disabled", true);
                                $("#addSocialMediaBtn").prop("disabled", true);
                                $("#CancelSocialMedia").prop("disabled", true);
                            } else {
                                $("#addSocialMediaBtn").val("Saving ...");
                                $("#addSocialMediaBtn").prop("disabled", true);
                                $("#addAndContinueSocialMediaBtn").prop("disabled", true);
                                $("#CancelSocialMedia").prop("disabled", true);
                            }
                        }
                    } else {
                        var data = {
                            title: self.title,
                            imagePath: self.imagesPaths,
                            imageSize: self.imagesSize,
                            imageType: self.imagesType,
                            companies_id: companiesId,
                            description: self.description,
                            hashtag: self.hashTag,
                            startDate: start_date,
                            contactPerson: self.userId,
                            contactEmail: self.contactEmail,
                            contactNumber: self.contactNumber,
                        };
                        if (flag == "Save and Continue") {
                            $("#addAndContinueSocialMediaBtn").val("Saving ...");
                            $("#addAndContinueSocialMediaBtn").prop("disabled", true);
                            $("#addSocialMediaBtn").prop("disabled", true);
                            $("#CancelSocialMedia").prop("disabled", true);
                        } else {
                            $("#addSocialMediaBtn").val("Saving ...");
                            $("#addSocialMediaBtn").prop("disabled", true);
                            $("#addAndContinueSocialMediaBtn").prop("disabled", true);
                            $("#CancelSocialMedia").prop("disabled", true);
                        }
                    }

                    HTTP.post("addupdatesocialmedia", data, config)
                            .then(function (response) {
                                if (segments[2] == 'updatesocialmediaentry') {
                                    if (segments[3]) {
                                        $("#addSocialMediaBtn").val("Update");
                                        $("#addSocialMediaBtn").prop("disabled", false);
                                        $("#CancelSocialMedia").prop("disabled", false);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueSocialMediaBtn").val("Save and Continue");
                                            $("#addAndContinueSocialMediaBtn").prop("disabled", false);
                                            $("#addSocialMediaBtn").prop("disabled", false);
                                            $("#CancelSocialMedia").prop("disabled", false);
                                        } else {
                                            $("#addSocialMediaBtn").val("Save");
                                            $("#addSocialMediaBtn").prop("disabled", false);
                                            $("#addAndContinueSocialMediaBtn").prop("disabled", false);
                                            $("#CancelSocialMedia").prop("disabled", false);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueSocialMediaBtn").val("Save and Continue");
                                        $("#addAndContinueSocialMediaBtn").prop("disabled", false);
                                        $("#addSocialMediaBtn").prop("disabled", false);
                                        $("#CancelSocialMedia").prop("disabled", false);
                                    } else {
                                        $("#addSocialMediaBtn").val("Save");
                                        $("#addSocialMediaBtn").prop("disabled", false);
                                        $("#addAndContinueSocialMediaBtn").prop("disabled", false);
                                        $("#CancelSocialMedia").prop("disabled", false);
                                    }
                                }

                                if (response.data.message == "success") {
                                    $("#errorMsg").html(response.data.content);
                                    $(".alert-danger").removeClass("hide");
                                    $(".alert-danger").addClass("show");
                                    if (flag == "Save and Continue") {
                                        self.removeAllFiles();
                                        $(".alert-success").addClass("show");
                                        self.title = '';
                                        self.companies = '';
                                        self.description = '';
                                        self.hashTag = '';
                                        self.startDate = new Date();
                                        self.createdBy = self.userId = userJson.first_name + " " + userJson.last_name;
                                        self.contactEmail = userJson.email;
                                        self.contactNumber = userJson.phone;
                                        self.userArr = [];
                                        self.imagesPaths = [];
                                        self.imagesSize = [];
                                        self.imagesType = [];
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        $(".back_button").prop("disabled", true);
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                            self.buttonBack();
                                        }, 3000);
                                    }
                                } else {
                                    $("#alertError").show();
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < response.data.content.length; i++) {
                                            err += response.data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                    }
                                    setTimeout(function () {
                                        $(".alert-danger").removeClass("show");
                                        $(".alert-danger").addClass("hide");
                                    }, 5000);
                                }
                            })
                            .catch(function (err) {
                                self.removeAllFiles();
                                if (segments[2] == 'updatesocialmediaentry') {
                                    if (segments[3]) {
                                        $("#addSocialMediaBtn").val("Update");
                                        $("#addSocialMediaBtn").prop("disabled", false);
                                        $("#CancelSocialMedia").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueSocialMediaBtn").prop("disabled", false);
                                            $("#addAndContinueSocialMediaBtn").val("Save and Continue");
                                            $("#addSocialMediaBtn").prop("disabled", false);
                                            $("#CancelSocialMedia").prop("disabled", false);
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            self.title = '';
                                            self.companies = '';
                                            self.description = '';
                                            self.hashTag = '';
                                            self.startDate = new Date();
                                            self.createdBy = self.userId = userJson.first_name + " " + userJson.last_name;
                                            self.contactEmail = userJson.email;
                                            self.contactNumber = userJson.phone;
                                            self.userArr = [];
                                            self.imagesPaths = [];
                                            self.imagesSize = [];
                                            self.imagesType = [];
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        } else {
                                            $("#addSocialMediaBtn").val("Save");
                                            $("#addSocialMediaBtn").prop("disabled", false);
                                            $("#addAndContinueSocialMediaBtn").prop("disabled", true);
                                            $("#CancelSocialMedia").prop("disabled", false);
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }

                                        if (err.response.status == 0) {
                                            self.errorMsg = "Remote server can not be reachable";
                                        } else {
                                            if (err.response.status == 401) {
                                                //clear previous data
                                                localStorage.removeItem("user_obj");
                                                localStorage.removeItem("api_token");
                                                localStorage.removeItem("profile_image");
                                                self.$router.push("/login");
                                            }
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueSocialMediaBtn").prop("disabled", false);
                                        $("#addAndContinueSocialMediaBtn").val("Save and Continue");
                                        $("#addSocialMediaBtn").prop("disabled", false);
                                        $("#CancelSocialMedia").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        self.title = '';
                                        self.companies = '';
                                        self.description = '';
                                        self.hashTag = '';
                                        self.startDate = new Date();
                                        self.createdBy = self.userId = userJson.first_name + " " + userJson.last_name;
                                        self.contactEmail = userJson.email;
                                        self.contactNumber = userJson.phone;
                                        self.userArr = [];
                                        self.imagesPaths = [];
                                        self.imagesSize = [];
                                        self.imagesType = [];
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        $("#addSocialMediaBtn").val("Save");
                                        $("#addSocialMediaBtn").prop("disabled", false);
                                        $("#addAndContinueSocialMediaBtn").prop("disabled", true);
                                        $("#CancelSocialMedia").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }

                                    if (err.response.status == 0) {
                                        self.errorMsg = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            //EventBus.$emit("logged-in", true, "", "");
                                            self.$router.push("/login");
                                        }
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }
                                }
                            });
                }
            },
            loadCompanies(search) {

                var config = {
                    //headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        search: search
                    }
                };
                HTTP.get("getcompany", config)
                        .then(function (response) {
                            self.companyArr = [];
                            $.each(response.data.content, function (i) {
                                /*self.companyArr.push(response.data.content[i].text);*/
                                self.companyArr.push(response.data.content[i]);
                            });
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            changeDateFormat: function (dateTime) {
                var parts = dateTime.split(" ");
                var time = parts[1];
                var hours = Number(time.match(/^(\d+)/)[1]);
                var minutes = Number(time.match(/:(\d+)/)[1]);
                var AMPM = '';
                if (time.indexOf('PM') != -1) {
                    AMPM = 'PM';
                } else {
                    AMPM = 'AM';
                }
                if (AMPM == "PM" && hours < 12)
                    hours = hours + 12;
                if (AMPM == "AM" && hours == 12)
                    hours = hours - 12;
                var sHours = hours.toString();
                var sMinutes = minutes.toString();
                if (hours < 10)
                    sHours = "0" + sHours;
                if (minutes < 10)
                    sMinutes = "0" + sMinutes;
                return new Date(parts[0] + " " + sHours + ":" + sMinutes + ":00");
            },

        }
    }
    EventBus.$on('role', function (isLogin, id, name, system_year, userPermissions) {
        if (typeof (self) != "undefined") {
            self.isShowLoggedinfields = isLogin;
            self.roleId = id;
            self.userPermissions = userPermissions;
            self.roleName = name;
            self.system_year = system_year;
        }
    });
</script>



// WEBPACK FOOTER //
// src/components/backend/socialmediacalendar/AddSocialEvent.vue